import { render, staticRenderFns } from "./Odometer.vue?vue&type=template&id=590d4a7d&"
import script from "./Odometer.vue?vue&type=script&lang=js&"
export * from "./Odometer.vue?vue&type=script&lang=js&"
import style0 from "./Odometer.vue?vue&type=style&index=0&id=590d4a7d&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports